<template>
  <div>
    <div>
      <country-flag :country="booking.route.origin.country" />
      <b>{{ $t('bookings.from') }}:</b>
      {{ origin }}
    </div>
    <div>
      <country-flag :country="booking.route.destination.country" />
      <b>{{ $t('bookings.to') }}:</b>
      {{ destination }}
    </div>
    <div v-if="showReturn">
      <country-flag :country="booking.return_booking.route.origin.country" />
      <b>{{ $t('bookings.return_from') }}:</b>
      {{ returnOrigin }}
    </div>
  </div>
</template>

<script>
import CountryFlag from 'vue-country-flag'

export default {
  name: 'BookingRoute',
  components: {
    CountryFlag,
  },
  props: {
    booking: {
      type: Object,
      required: true,
    },
    showFullAddress: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    origin() {
      if (this.booking.origin) {
        return this.booking.origin.name
      }
      return this.showFullAddress
        ? this.booking.route.origin.address
        : this.booking.route.origin.city
    },
    destination() {
      if (this.booking.destination) {
        return this.booking.destination.name
      }
      return this.showFullAddress
        ? this.booking.route.destination.address
        : this.booking.route.destination.city
    },
    returnOrigin() {
      return this.showFullAddress
        ? this.booking.return_booking.route.origin.address
        : this.booking.return_booking.route.origin.city
    },
    showReturn() {
      return (
        this.booking.return_booking &&
        (this.booking.return_booking.status !== 'cancelled' ||
          this.booking.status === 'cancelled')
      )
    },
  },
}
</script>
